import React, { useState, useEffect, useContext } from "react";
import { AiOutlineCloudDownload } from "react-icons/ai";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";
import Axios from "axios";
import Navigations from "../../common/useNavigation";
const ExporttoExcel = ({ userDetails }) => {

  const {navigateSellerBulkUploadExcelsheet} = Navigations();
  // const [sheetdata, setSheetdata] = useState([]);
  const fileType = "Xlsx";
  const navigate = useNavigate();
  var tab = [];
  var temp;
  for (var i = 0; i < userDetails.length; i++) {
    temp = userDetails[i]["attributeName"];
    tab.push(temp);
  }
  const downloadexcelsheet = async () => {



    const axiosJWT = Axios.create();
    axiosJWT.interceptors.request.use(async (config) => {
      const accessToken = localStorage.getItem('authToken');
      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }
      return config;
    }, (error) => {
      return Promise.reject(error);
    });

    const response = await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/Getmeasurementlist`,{},{ withCredentials: true, credentials: 'include' });
    const newTabData = response.data.data;
    const reducedArray = newTabData.reduce((acc, item) => {
      acc.push({ MeasurementName: item.measurement_name });
      return acc;
    }, []);
    
    const numbers = [];
    const ws = XLSX.utils.json_to_sheet(numbers);
    XLSX.utils.sheet_add_aoa(ws, [tab], { origin: "A1" });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, ws, "Products");

    // Create a new sheet with additional data
    // const newTabData = []; // Populate this with the data you want in the new tab
    const newWs = XLSX.utils.json_to_sheet(reducedArray);
    XLSX.utils.sheet_add_aoa(newWs, [["Measurement"]], { origin: "A1" }); // Add headers if needed

    // Append the new sheet to the workbook
    XLSX.utils.book_append_sheet(workbook, newWs, "Measurement"); // Change "NewTabName" to your desired sheet name

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, "Selzor_Attributes(DONT__CHANGE__COLUMN__NAME)" + ".xlsx");

    setTimeout(() => {
      navigateSellerBulkUploadExcelsheet();
    }, 5000);
  };
  return (
    <button className="relative group text-sm rounded-md items-center bg-[#0bb29f] hover:bg-[#0bb29f] w-full px-2 mx-2" onClick={downloadexcelsheet} >
      <span className="relative text-sm text-white font-semibold">
        Download Excelsheet for Bulk product Upload
      </span>
    </button>
  );
};

export default ExporttoExcel;
